import { _t } from '../base'

export function initStep3() {
    if ($('.id--17').length) {
        moveStep3Elements()
        loginLink()
        freePrice()
        step3TextChanges()
    }
}

function loginLink() {
    const loginLink = $('#order-page-login-button')
    loginLink
        .insertAfter('.co-contact-information > h4')
        .wrap('<div class="form-group"></div>')
        .attr('data-target', 'login')
        .addClass('toggle-window')
        .text(_t('cart.step3.loginLink'))
}

function moveStep3Elements() {
    $('.form-group.company-shopping').insertAfter('.form-group:has(#another-shipping)')
}

function step3TextChanges() {
    // $('#submit-order').text('cart3')
}

function freePrice() {
    const shippingAndBilling = $(".order-summary-item:not([data-micro='cartItem'])")

    shippingAndBilling.each(function () {
        const price = $(this).find('.cart-item-price')
        if (price.text().trim() === '0 Kč') {
            $(this).addClass('free-price')
            price.text('Zdarma')
        }
    })
}
